import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import {
  isUserLoggedIn,
  appSubdomain,
  currentOtp,
  currentAnonGroupId,
} from '../graphql/stores/local'
import { readGetUserVar } from '../graphql/stores/user'
import { buildHeaders } from './fetchUtils'
import { SERVER_GRAPHQL_API_URI } from '../constants'

const createClient = () => {
  const cache = new InMemoryCache({
    typePolicies: {
      Query: {
        isUserLoggedIn,
        readGetUserVar,
        appSubdomain,
        currentOtp,
        currentAnonGroupId,
      },
    },
  })
  const uri = SERVER_GRAPHQL_API_URI
  const httpLink = createHttpLink({
    uri,
  })

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...buildHeaders(headers),
      },
    }
  })
  // console.log(uri)
  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    uri,
    ssrMode: false,
    cache,
    connectToDevTools: process.env.NODE_ENV !== 'production',
    queryDeduplication: true,
  })
  return client
}

export default createClient
